module.exports = __webpack_public_path__ + "static/media/API.5646ef15.png";